import { useTranslation } from 'react-i18next'
import './VehicleImagePlaceholder.css'

function VehicleImagePlaceholder({ className = '' }) {
  const { t } = useTranslation()
  const label = t('listings.noPhoto')

  return (
    <div
      className={`vehicle-image-placeholder ${className}`.trim()}
      role="img"
      aria-label={label}
    >
      <span className="vehicle-image-placeholder__text">{label}</span>
    </div>
  )
}

export default VehicleImagePlaceholder
